module.exports = __webpack_public_path__ + "img/banner-about.6bd5f721.png";